module.exports = __webpack_public_path__ + "img/crystal500.d0f25c4a.jpg";